import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "icon" | "link";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
  children: ReactNode;
}

const VARIANT_STYLES: Record<Variant, string> = {
  primary:
    "rounded-md bg-(--accent-color,#3b82f6) px-4 py-2 text-sm font-medium text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50",
  secondary:
    "rounded-md bg-(--secondary-background,#e5e7eb) px-4 py-2 text-sm font-medium text-(--text-color,#111) transition-opacity hover:opacity-90",
  icon:
    "flex size-8 items-center justify-center rounded-md border-none bg-(--secondary-background,#e5e7eb) text-(--text-muted,#6b7280) transition-colors hover:bg-(--border-color,#d1d5db) hover:text-(--text-color,#111)",
  link:
    "bg-transparent text-xs text-(--text-muted,#6b7280) hover:underline",
};

export function Button({
  variant = "primary",
  fullWidth = false,
  className = "",
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`cursor-pointer border-none ${VARIANT_STYLES[variant]} ${fullWidth ? "w-full" : ""} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
